/* eslint-disable no-unused-expressions */

import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Container } from 'reactstrap'

import {
  fetchHomepageIfNeeded,
  fetchTopicDetailsIfNeeded,
  fetchTopicPlanIfNeeded,
  fetchTopicPlanTopLevelMetricsIfNeeded,
  fetchTopicPlanDemoIfNeeded,
  fetchTopicPlanExportIfNeeded,
  fetchTopicPlanAnticipationIfNeeded,
  setTopicPlanFilters,
  resetTopicPlanFilters,
  setSelectedSidebarNav,
  logout
} from '../../actions'
import {
  makeTopicIdSelector,
  makeTopicDetailsSelector,
  makeTopicPlanSelector,
  makeTopicPlanFiltersSelector,
  makeTopicPlanSelectedFiltersSelector,
  makeTopicMetricsSelector,
  makeTopicPlanSegments,
  makeTopicPlanDemographics,
  makeTopicPlanAnticipation,
  makeTopicPlanExportSelector
} from '../../selectors'
import { DefaultFilters } from '../../reducers/topics_reducer'
import AudienceHeaderComponent from '../../components/audience/AudienceHeaderComponent'
import AudienceMediaComponent from '../../components/audience/AudienceMediaComponent'
import AudienceBrandComponent from '../../components/audience/AudienceBrandComponent'
import AudienceDemoComponent from '../../components/audience/AudienceDemoComponent'
import AudienceAnticipationComponent from '../../components/audience/AudienceAnticipationComponent'
import Profile from '../../classes/profile'
import SidebarComponent from '../../components/sidebar/SidebarComponent'
import { MEDIA_PREFERENCE, BRAND_PREFERENCE, DEMOGRAPHICS, ANTICIPATION, MEDIA_PLANNING, MEDIA_PLANNING_SHORTCUT } from '../../constants/commons'

import '../../components/audience/AudienceComponent.scss'
import AudienceMediaPlanningComponent from '../../components/audience/AudienceMediaPlanningComponent'
import { fetchTopicMediaPlanIfNeeded } from '../../actions/topics_actions'
import { makeTopicMediaPlan } from '../../selectors/media_planning_selector'

class AudienceContainer extends React.Component {
  static propTypes = {
    isAdmin: PropTypes.bool.isRequired,
    profile: Profile.PropTypes,
    homepage: PropTypes.object,
    topic: PropTypes.object,
    logout: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    selectedPlanFilters: PropTypes.object.isRequired,
    tlmFilters: PropTypes.array.isRequired,
    programmingFilters: PropTypes.array.isRequired,
    otherFilters: PropTypes.array.isRequired,
    setFilters: PropTypes.func.isRequired,
    resetFilters: PropTypes.func.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired,
      target: PropTypes.string.isRequired,
      target_id: PropTypes.string.isRequired
    }),
    topicDetails: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }).isRequired,
    topicPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      currentPage: PropTypes.number.isRequired,
      endOfResult: PropTypes.bool.isRequired,
      planFilters: PropTypes.object.isRequired,
      details: PropTypes.object
    }).isRequired,
    topicPlanTopLevelMetrics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }).isRequired,
    topicPlanDemographics: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    topicMediaPlan: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.object
    }),
    topicPlanAnticipation: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      currentPage: PropTypes.number.isRequired,
      endOfResult: PropTypes.bool.isRequired,
      planFilters: PropTypes.object.isRequired,
      details: PropTypes.object
    }),
    topicPlanSegments: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object,
      details: PropTypes.array
    }).isRequired,
    fetchHomepage: PropTypes.func.isRequired,
    fetchDetails: PropTypes.func.isRequired,
    fetchPlan: PropTypes.func.isRequired,
    fetchMediaPlan: PropTypes.func.isRequired,
    fetchPlanTopLevelMetrics: PropTypes.func.isRequired,
    fetchDemo: PropTypes.func.isRequired,
    fetchTopicPlanAnticipation: PropTypes.func.isRequired,
    exportPlan: PropTypes.func.isRequired,
    setShortcutPreference: PropTypes.func,
    shortcutPreference: PropTypes.string,
    selectedNav: PropTypes.string,
    isContentIntelligence: PropTypes.bool,
    isCatalogAnalysis: PropTypes.bool,
    isPerformanceAnalysis: PropTypes.bool,
    isAIInsights: PropTypes.bool,
    selectedSidebarNav: PropTypes.func,
    planExport: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      error: PropTypes.object
    })
  }

  constructor (props) {
    super(props)

    this.state = {
      anticipationPlan: this.props.topicPlan,
      screenWidth: window.innerWidth
    }
    this.export = this.export.bind(this)
    this.exportFilteredPlan = this.exportFilteredPlan.bind(this)
  }

  componentDidMount () {
    if (this.props.profile && this.props.profile.groups.length > 0) {
      const groups = this.props.profile.groups
      const groupName = groups.filter(group => group !== 'Admin')[0]
      this.props.fetchHomepage(groupName)
    }
    this.props.fetchDetails()
    this.props.fetchPlanTopLevelMetrics()
    this.props.fetchDemo()
    window.addEventListener('resize', this.updateDimensions)
  }

  updateDimensions = () => {
    this.setState({ screenWidth: window.innerWidth })
  }

  fetchTopicPlan = (module, mode, searchKeyword, isSearch) => {
    const args = {
      filters: this.props.filters
    }
    if (searchKeyword) {
      args.search = searchKeyword,
      args.page = 1
    }
    this.props.fetchPlan(args, module, mode, isSearch)
  }

  loadMore = () => {
    const args = {
      page: this.props.topicPlan.currentPage + 1,
      filters: this.props.filters
    }
    this.props.fetchPlan(args)
  }

  export () {
    let name = this.props.topicDetails.details.name
    const filename = `${name} Audience.xlsx`
    this.props.exportPlan(filename, this.props.filters, false)
  }

  exportFilteredPlan () {
    let name = this.props.topicDetails.details.name
    const filename = `${name} Audience.xlsx`
    this.props.exportPlan(filename, this.props.filters, true)
  }

  render () {
    const {profile, homepage, topic, location, selectedNav, isContentIntelligence, isCatalogAnalysis, isPerformanceAnalysis, isAIInsights} = this.props
    const myLogout = () => this.props.logout()
    return (
      <>
        <SidebarComponent
          isAdmin={this.props.isAdmin}
          profile={profile}
          topic={topic}
          logout={myLogout}
          location={location}
          shortcut={this.props.shortcut}
          homepage={homepage}
          shortcutPreference={this.props.shortcutPreference}
          setShortcutPreference={this.props.setShortcutPreference}
          selectedSidebarNav={this.props.selectedSidebarNav}
          selectedNav={selectedNav}
          isContentIntelligence={isContentIntelligence}
          isCatalogAnalysis={isCatalogAnalysis}
          isPerformanceAnalysis={isPerformanceAnalysis}
          isAIInsights={isAIInsights}
        />
        <div className="rightSide">
          <Container fluid={true}>
            <AudienceHeaderComponent
              profile={this.props.profile}
              topicDetails={this.props.topicDetails}
              exportPlan={this.export}
              exportFilteredPlan={this.exportFilteredPlan}
              location={location}
              shortcut={this.props.shortcut}
              planExport={this.props.planExport}
            />
            { ((this.props.shortcut && this.props.shortcut.target !== MEDIA_PLANNING_SHORTCUT && this.props.shortcutPreference === MEDIA_PREFERENCE) || (this.props.location && this.props.location.pathname.includes(MEDIA_PREFERENCE))) &&
              <AudienceMediaComponent
                isAdmin={this.props.isAdmin}
                profile={this.props.profile}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                location={this.props.location}
                loadMore={this.loadMore}
                filters={this.props.filters}
                selectedPlanFilters={this.props.selectedPlanFilters}
                tlmFilters={this.props.tlmFilters}
                programmingFilters={this.props.programmingFilters}
                otherFilters={this.props.otherFilters}
                setFilters={this.props.setFilters}
                resetFilters={this.props.resetFilters}
                topicDetails={this.props.topicDetails}
                topicPlan={this.props.topicPlan}
                topLevelMetrics={this.props.topicPlanTopLevelMetrics}
                screenWidth={this.state.screenWidth}
                fetchTopicPlan={this.fetchTopicPlan}
                />
            }
            { ((this.props.shortcut && this.props.shortcutPreference === BRAND_PREFERENCE) || (this.props.location && this.props.location.pathname.includes(BRAND_PREFERENCE))) &&
              <AudienceBrandComponent
                isAdmin={this.props.isAdmin}
                profile={this.props.profile}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                location={this.props.location}
                loadMore={this.loadMore}
                filters={this.props.filters}
                selectedPlanFilters={this.props.selectedPlanFilters}
                tlmFilters={this.props.tlmFilters}
                programmingFilters={this.props.programmingFilters}
                otherFilters={this.props.otherFilters}
                setFilters={this.props.setFilters}
                resetFilters={this.props.resetFilters}
                topicDetails={this.props.topicDetails}
                topicPlan={this.props.topicPlan}
                topLevelMetrics={this.props.topicPlanTopLevelMetrics}
                screenWidth={this.state.screenWidth}
                fetchTopicPlan={this.fetchTopicPlan}
                />
            }
            { ((this.props.shortcut && this.props.shortcutPreference === DEMOGRAPHICS) || (this.props.location && this.props.location.pathname.includes(DEMOGRAPHICS))) &&
              <AudienceDemoComponent
                isAdmin={this.props.isAdmin}
                profile={this.props.profile}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                location={this.props.location}
                loadMore={this.loadMore}
                filters={this.props.filters}
                selectedPlanFilters={this.props.selectedPlanFilters}
                programmingFilters={this.props.programmingFilters}
                otherFilters={this.props.otherFilters}
                setFilters={this.props.setFilters}
                resetFilters={this.props.resetFilters}
                topicDetails={this.props.topicDetails}
                topicPlan={this.props.topicPlan}
                topicPlanDemographics={this.props.topicPlanDemographics}
                topicPlanSegments={this.props.topicPlanSegments}
                screenWidth={this.state.screenWidth}
                fetchTopicPlan={this.fetchTopicPlan}
                />
            }
            { ((this.props.shortcut && this.props.shortcutPreference === ANTICIPATION) || (this.props.location && this.props.location.pathname.includes(ANTICIPATION))) &&
              <AudienceAnticipationComponent
                isAdmin={this.props.isAdmin}
                profile={this.props.profile}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                location={this.props.location}
                loadMore={this.loadMore}
                filters={this.props.filters}
                selectedPlanFilters={this.props.selectedPlanFilters}
                tlmFilters={this.props.tlmFilters}
                programmingFilters={this.props.programmingFilters}
                setFilters={this.props.setFilters}
                resetFilters={this.props.resetFilters}
                topicDetails={this.props.topicDetails}
                topicPlan={this.props.topicPlan}
                topicPlanAnticipation={this.props.topicPlanAnticipation}
                fetchTopicPlan={this.fetchTopicPlan}
                />
            }
            { ((this.props.shortcut && this.props.shortcutPreference === MEDIA_PLANNING) || (this.props.location && this.props.location.pathname.includes(MEDIA_PLANNING) && this.props.isAdmin) || (this.props.shortcut && this.props.shortcut.target === MEDIA_PLANNING_SHORTCUT)) &&
              <AudienceMediaPlanningComponent
                isAdmin={this.props.isAdmin}
                profile={this.props.profile}
                shortcut={this.props.shortcut}
                shortcutPreference={this.props.shortcutPreference}
                location={this.props.location}
                fetchMediaPlan={this.props.fetchMediaPlan}
                topicMediaPlan={this.props.topicMediaPlan}
              />
            }
          </Container>
        </div>
      </>
    )
  }
}

/* Second part of memoizing selectors */
const mapStateToProps = () => {
  const planSelector = makeTopicPlanSelector()
  const filtersSelector = makeTopicPlanFiltersSelector()
  const slelectedFiltersSelector = makeTopicPlanSelectedFiltersSelector()
  const tlmSelector = makeTopicMetricsSelector()
  const detailsSelector = makeTopicDetailsSelector()
  const topicSegments = makeTopicPlanSegments()
  const topicDemographics = makeTopicPlanDemographics()
  const topicMediaPlanning = makeTopicMediaPlan()
  const anticipationPlanSelector = makeTopicPlanAnticipation()
  const topicPlanExportSelector = makeTopicPlanExportSelector()

  return (state, ownProps) => {
    const isAdmin = state.user.isAdmin
    const profile = state.user.profile && new Profile(state.user.profile)
    const topic = state.topics.byId
    const topicDetails = detailsSelector(state, ownProps)
    const topicPlan = planSelector(state, ownProps)
    const planFilters = filtersSelector(state, ownProps)
    const filters = planFilters.filters // It is returned in a struct
    const selectedPlanFilters = slelectedFiltersSelector(state, ownProps)
    const tlmFilters = selectedPlanFilters.tlmFilters || []
    const programmingFilters = selectedPlanFilters.programmingFilters || []
    const otherFilters = selectedPlanFilters.otherFilters || []
    const topicPlanTopLevelMetrics = tlmSelector(state, ownProps)
    const topicPlanSegments = topicSegments(state, ownProps)
    const topicPlanDemographics = topicDemographics(state, ownProps)
    const topicMediaPlan = topicMediaPlanning(state, ownProps)
    const topicPlanAnticipation = anticipationPlanSelector(state, ownProps)
    const shortcut = ownProps.shortcut
    const homepage = state.homepage.list
    const selectedNav = state.sidebar.selectedNav
    const isContentIntelligence = state.sidebar.isContentIntelligence
    const isCatalogAnalysis = state.sidebar.isCatalogAnalysis
    const isPerformanceAnalysis = state.sidebar.isPerformanceAnalysis
    const isAIInsights = state.sidebar.isAIInsights
    const planExport = topicPlanExportSelector(state, ownProps)

    return {
      isAdmin,
      profile,
      shortcut,
      homepage,
      topic,
      topicDetails,
      filters,
      selectedPlanFilters,
      tlmFilters,
      programmingFilters,
      otherFilters,
      topicPlan,
      topicPlanTopLevelMetrics,
      topicPlanSegments,
      topicPlanDemographics,
      topicMediaPlan,
      topicPlanAnticipation,
      selectedNav,
      isContentIntelligence,
      isCatalogAnalysis,
      isPerformanceAnalysis,
      isAIInsights,
      planExport
    }
  }
}

const defaultPlanArgs = {
  page: 1,
  filters: DefaultFilters
}

function mapDispatchToProps () {
  const topicIdSelector = makeTopicIdSelector()
  return (dispatch, props) => {
    const topicId = topicIdSelector(null, props)
    return {
      fetchHomepage: (groupName) => dispatch(fetchHomepageIfNeeded(groupName)),
      fetchDetails: () => dispatch(fetchTopicDetailsIfNeeded(topicId)),
      fetchPlan: (args = defaultPlanArgs, module, mode, isSearch) => dispatch(fetchTopicPlanIfNeeded(topicId, args, module, mode, isSearch)),
      fetchMediaPlan: () => dispatch(fetchTopicMediaPlanIfNeeded(topicId)),
      fetchPlanTopLevelMetrics: () => dispatch(fetchTopicPlanTopLevelMetricsIfNeeded(topicId)),
      exportPlan: (filename, filters, exportFilters) => dispatch(fetchTopicPlanExportIfNeeded(topicId, filename, filters, exportFilters)),
      setFilters: (filters, filterType, module, mode) => dispatch(setTopicPlanFilters(topicId, filters, filterType, module, mode)),
      resetFilters: () => dispatch(resetTopicPlanFilters(topicId)),
      fetchDemo: () => dispatch(fetchTopicPlanDemoIfNeeded(topicId)),
      fetchTopicPlanAnticipation: () => dispatch(fetchTopicPlanAnticipationIfNeeded(topicId)),
      selectedSidebarNav: (nav) => dispatch(setSelectedSidebarNav(nav)),
      logout: () => dispatch(logout())
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AudienceContainer)
